// The boards' button vocabulary (foundations/kit.css § Buttons). Quies does not build on
// `core/ui/Button`: its variants are narcis's (animated gradient, Absans 600, hover lift and glow,
// from narcis's partials through `@styles`), and restyling them from a sibling module is a fight
// over cascade order that only `!important` wins.
// Hover rules restate the text colour: on a link, the global `a:hover` gold outranks one class.
@mixin base {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--qs-space-8);
  min-height: var(--qs-target-option-min-height);
  padding: 0 var(--qs-space-24);
  border: 1px solid transparent;
  border-radius: var(--qs-radius-pill);
  background: transparent;
  color: var(--qs-color-text);
  font-family: var(--qs-font-text);
  font-size: var(--qs-type-label-size);
  font-weight: 400;
  letter-spacing: 0.02em;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  transition: background-color var(--qs-motion-dur-fade) var(--qs-motion-ease-settle),
    border-color var(--qs-motion-dur-fade) var(--qs-motion-ease-settle),
    box-shadow var(--qs-motion-dur-fade) var(--qs-motion-ease-settle),
    color var(--qs-motion-dur-fade) var(--qs-motion-ease-settle);

  &:focus-visible {
    outline: 2px solid var(--qs-color-focus);
    outline-offset: 2px;
  }

  &:disabled {
    color: var(--qs-color-text-disabled);
    border-color: var(--qs-color-line);
    background: transparent;
    box-shadow: none;
    cursor: default;
  }
}

// Gold hairline: "can be pressed" (decisions.md §5).
.primary {
  @include base;
  border-color: var(--qs-color-accent);

  &:hover:not(:disabled) {
    background: var(--qs-color-accent-tint);
    border-color: var(--qs-color-accent-strong);
    color: var(--qs-color-text);
  }
}

// The one filled shape on a screen where nothing plays (decisions.md §5).
.lit {
  @include base;
  background: var(--qs-color-glow-core);
  color: var(--qs-color-on-light);
  font-weight: 500;
  box-shadow: var(--qs-elev-glow-play);

  &:hover:not(:disabled) {
    color: var(--qs-color-on-light);
    box-shadow: 0 0 0 8px var(--qs-color-glow-ring), 0 0 40px 8px color-mix(in srgb, var(--qs-color-glow-core) 22%, transparent);
  }
}

.quiet {
  @include base;
  color: var(--qs-color-text-soft);
  padding: 0 var(--qs-space-16);

  &:hover:not(:disabled) {
    color: var(--qs-color-text);
    background: color-mix(in srgb, var(--qs-color-silver) 8%, transparent);
  }
}

.large {
  min-height: 56px;
  padding: 0 var(--qs-space-40);
  font-size: var(--qs-type-body-size);
}

// The navbar's Begin Session: a target, not a call to arms.
.compact {
  min-height: var(--qs-target-min);
  padding: 0 var(--qs-space-20);
}

.block {
  width: 100%;
}
